export const PLAYER_LOADED = 'PLAYER_LOADED';
export const CONTENT_STARTED = 'CONTENT_STARTED';
export const CONTENT_PAUSED = 'CONTENT_PAUSED';
export const CONTENT_RESUMED = 'CONTENT_RESUMED';
export const CONTENT_COMPLETED = 'CONTENT_ENDED';
export const AD_BLOCK_STARTED = 'AD_BLOCK_STARTED';
export const AD_BLOCK_COMPLETED = 'AD_BLOCK_COMPLETED';
